module.exports = __webpack_public_path__ + "media/flags/km-4fb5c60d.svg";